import axios from 'axios';
import store from '../redux/store';
import { setAccessTokenInReducer, setLoginDetails, setIsLoggedIn } from '../redux/reducers/auth-reducer';
import { ActionTypes } from '../redux/type';
import showToast from '../utils/toast';

let isRefreshing = false;
let failedQueue: any[] = [];

const processQueue = (error: any, token = null) => {
  failedQueue.forEach(prom => {
    if (token) {
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });

  failedQueue = [];
};

const createNetworkService = () => {
  const client = axios.create({ baseURL: process.env.REACT_APP_UAT_URL, headers: { 'Content-Type': 'application/json' } });
  client.interceptors.request.use((request: any) => {
    if (request.skipAuth) return request;
    const state = store.getState();
    const token =
      state?.auth?.loginDetails?.user_details?.[0]?.access_token ?? null;
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
  });

  client.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      const state = store.getState();
      const refreshToken = state?.auth?.loginDetails?.user_details?.[0]?.refresh_token ?? null;
      if (error.response?.status === 401 && !originalRequest._retry && refreshToken) {
        if (isRefreshing) {
          return new Promise(function (resolve, reject) {
            failedQueue.push({ resolve, reject });
          })
            .then(token => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return client(originalRequest);
            })
            .catch(err => {
              return Promise.reject(err);
            });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        return new Promise(function (resolve, reject) {
          axios
            .post(`${process.env.REACT_APP_UAT_URL}api/auth/refresh/`, { refresh_token: refreshToken })
            .then(({ data }) => {
              // RefreshAPI answers {access, refresh}; older builds wrapped it in response.
              const accessToken = data.access ?? data.response?.access_token;
              const newRefresh = data.refresh ?? data.response?.refresh_token;
              store.dispatch(setAccessTokenInReducer(accessToken));
              const loginDetails = { ...state.auth?.loginDetails };
              if (loginDetails?.user_details?.length) {
                loginDetails.user_details = [...loginDetails.user_details];
                loginDetails.user_details[0] = {
                  ...loginDetails.user_details[0],
                  access_token: accessToken,
                  refresh_token: newRefresh,
                };
              }
              store.dispatch(setLoginDetails(loginDetails));
              client.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
              originalRequest.headers.Authorization = `Bearer ${accessToken}`;
              processQueue(null, accessToken);
              resolve(client(originalRequest));
            })
            .catch(err => {
              showToast("Login session expired", "e")
              store.dispatch(setIsLoggedIn(false));
              store.dispatch({ type: ActionTypes.GLOBAL_RESET, payload: undefined });
              processQueue(err, null);
              reject(err);

            })
            .finally(() => {
              isRefreshing = false;
            });
        });
      }
      return Promise.reject(error);
    }
  );

  const setAccessToken = (token: any) => {
    client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  };

  const clearAccessToken = () => {
    delete client.defaults.headers.common['Authorization'];
  };

  const request = ({ method, url, data, params, ...config }: any) => {
    return client.request({ method, url, params, data, ...config });
  };

  return {
    setAccessToken,
    clearAccessToken,
    request,
  };
};

export const networkService = createNetworkService();

// import axios from 'axios';
// import store from '../redux/store';
// import { setAccessTokenInReducer, setLoginDetails,setIsLoggedIn } from '../redux/reducers/auth-reducer';
// import { ActionTypes } from '../redux/type'; 
// import showToast from '../utils/toast';

// let isRefreshing = false; 
// let failedQueue: any[] = [];

// const processQueue = (error: any, token = null) => {
//   failedQueue.forEach(prom => {
//     if (token) {
//       prom.resolve(token);
//     } else {
//       prom.reject(error);
//     }
//   });

//   failedQueue = [];
// };

// const createNetworkService = () => {
//   const client = axios.create({ baseURL:process.env.REACT_APP_UAT_URL,headers:{'Content-Type': 'application/json'} });
//   client.interceptors.request.use((request: any) => {
//     if (request.skipAuth) return request;
//     const state = store.getState();
//     const token =
//     state?.auth?.loginDetails?.user_details?.[0]?.access_token;
//     if (token) {
//       request.headers.Authorization = `Bearer ${token}`;
//     }
//     return request;
//   });

//   client.interceptors.response.use(
//     (response) => {
//       return response;
//     },
//     async (error) => {
//       const originalRequest = error.config;
//       const state = store.getState();
//       const refreshToken = Array.isArray(state?.auth?.loginDetails?.user_details[0]) ? state.auth?.loginDetails?.userDetails[0]?.refresh_token : {};
//       if (error.response?.status === 401 && !originalRequest._retry && refreshToken) {
//         if (isRefreshing) {
//           return new Promise(function (resolve, reject) {
//             failedQueue.push({ resolve, reject });
//           })
//             .then(token => {
//               originalRequest.headers.Authorization = `Bearer ${token}`;
//               return client(originalRequest);
//             })
//             .catch(err => {
//               return Promise.reject(err);
//             });
//         }

//         originalRequest._retry = true;
//         isRefreshing = true;

//         return new Promise(function (resolve, reject) {
//           axios
//             .post(`${process.env.REACT_APP_UAT_URL}api/token/refresh/`, { refresh_token: refreshToken })
//             .then(({ data }) => {
//               store.dispatch(setAccessTokenInReducer(data.response.access_token));
//               const loginDetails = { ...state.auth?.loginDetails };

//               if (loginDetails && loginDetails.userDetails && loginDetails.userDetails[0]) {
//                 loginDetails.userDetails = [...loginDetails.userDetails];
//                 loginDetails.userDetails[0] = {
//                   ...loginDetails.userDetails[0],
//                   access_token: data.response.access_token,
//                   refresh_token: data.response.refresh_token,
//                 };
//               }
//               store.dispatch(setLoginDetails(loginDetails));
//               client.defaults.headers.common['Authorization'] = `Bearer ${data.response.access_token}`;
//               originalRequest.headers.Authorization = `Bearer ${data.response.access_token}`;
//               processQueue(null, data.response.access_token);
//               resolve(client(originalRequest));
//             })
//             .catch(err => {
//               showToast("Login session expired","e")
//               store.dispatch(setIsLoggedIn(false));
//               store.dispatch({ type: ActionTypes.GLOBAL_RESET, payload: undefined });
//               processQueue(err, null);
//               reject(err);

//             })
//             .finally(() => {
//               isRefreshing = false;
//             });
//         });
//       }
//       return Promise.reject(error);
//     }
//   );

//   const setAccessToken = (token: any) => {
//     client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
//   };

//   const clearAccessToken = () => {
//     delete client.defaults.headers.common['Authorization'];
//   };

//   const request = ({ method, url, data, params, ...config }: any) => {
//     return client.request({ method, url, params, data, ...config });
//   };

//   return {
//     setAccessToken,
//     clearAccessToken,
//     request,
//   };
// };

// export const networkService = createNetworkService();

